import { render } from "./SoccerAndHockeyCards.vue?vue&type=template&id=d40b13c8"
import script from "./SoccerAndHockeyCards.vue?vue&type=script&lang=js"
export * from "./SoccerAndHockeyCards.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_6e4c079c/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__